// =============================================
// manualUrlValidator — walidacja ręcznie wpisanego URL w LinkFixPreviewModal
// =============================================
//
// Akceptuje:
//   - Full URL: http(s)://... z poprawnym new URL() parse
//   - Relatywny path: ^/[^/\s].* (pojedynczy slash, NIE protocol-relative)
//
// Odrzuca:
//   - Pusty / whitespace-only
//   - Protocol-relative "//evil.com" (security: blokuje cross-origin injection
//     gdzie user mógłby wkleić "//attacker.com/exploit" myśląc że to relative)
//   - URL bez schematu ("foo bar", "domena.pl/foo")
//   - Malformed http:// / https://

export function isValidManualUrl(raw: string): boolean {
  if (typeof raw !== "string") return false;
  const trimmed = raw.trim();
  if (!trimmed) return false;

  // Full URL: http(s)://...
  if (/^https?:\/\//i.test(trimmed)) {
    try {
      new URL(trimmed);
      return true;
    } catch {
      return false;
    }
  }

  // Relatywny path: pojedynczy "/" + non-slash non-whitespace dalej.
  // Odrzuca protocol-relative "//..." (drugi znak NIE może być "/").
  return /^\/[^/\s].*$/.test(trimmed);
}
